
  <nav mat-tab-nav-bar [tabPanel]="tabContent">
    @for (tab of currentTabs; track tab.pathSegment) {
      <a
        mat-tab-link
        [routerLink]="tab.pathSegment | workspaceTabRoute: baseRoute"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive">
        {{ tab.label }}
      </a>
    }
  </nav>
  <div #tabContent>
    <router-outlet></router-outlet>
  </div>

